// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24x1L","newExpiryDate":"styles_newExpiryDate__3k7H_","footer":"styles_footer__3ZvOf"};